import { theme } from 'lib/theme'

import { useStore } from 'lib/store'
import { observer } from 'mobx-react-lite'
import { Flex } from 'primitives/Flex'
import { Text } from 'primitives/Text'
import { toJS } from 'mobx'

import { Icon } from 'common/Icon'

import { Banner } from './Components/Banner'
import { BannerLayout } from './Components/BannerLayout'
import { Anchor } from 'primitives/Anchor'
import { useRouter } from 'next/router'

const _ApplicationBanner: React.FC = () => {
  const { ui } = useStore()
  const router = useRouter()

  //https://mobx.js.org/observable-state.html#converting-observables-back-to-vanilla-javascript-collections
  const observerClone = toJS(ui.appBanner)
    // Remove banners that should not display on current path
    .filter((banner) => !banner.opts.disabledPages?.includes(router.pathname))
    .sort((a, b) => Number(b.opts.pinned) - Number(a.opts.pinned))

  return (
    <>
      {ui.appBanner.length > 0 && (
        <BannerLayout>
          {observerClone.map(
            ({ key, title, opts: { action, disableDismiss } }) => (
              <Flex
                css={{
                  justifyContent: 'center',
                  width: '100%',
                  backgroundColor: '$gray600',
                }}
                key={key}
              >
                <Banner>
                  <Flex row center css={{ gap: '5px' }}>
                    <Icon
                      icon='Exclamation'
                      css={{
                        '@xs': {
                          display: 'none',
                        },
                        '@md': {
                          display: 'block',
                          marginRight: 4,
                        },
                        '& .primary.stroke': {
                          stroke: theme.colors.gray900,
                        },
                      }}
                    />
                    <Text
                      type='body3'
                      css={{
                        color: '$gray900',
                      }}
                    >
                      {title}
                    </Text>
                    <Flex css={{ marginLeft: 4 }}>{action ?? <></>}</Flex>
                  </Flex>
                  {!disableDismiss && (
                    <Anchor
                      className='close-link'
                      onClick={() => ui.hideBanner(key)}
                    >
                      <Icon icon='Cross' />
                    </Anchor>
                  )}
                </Banner>
              </Flex>
            )
          )}
        </BannerLayout>
      )}
    </>
  )
}

export const ApplicationBanner = observer(_ApplicationBanner)
